// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"8e6f1f8c","268":"56ee3d02"}[chunkId] + ".chunk.js";
};